<h4>{{ create ? 'Create' : 'Edit' }} {{ branchLabel | lowercase }}</h4>
<mat-dialog-content class="flex flex-col">
	<atomic-institution-badge
		[institution]="institutionBadgeDetails"
		size="small"
	>
	</atomic-institution-badge>

	<form [formGroup]="form" novalidate class="px-1">
		<div
			*ngIf="mortgageeType !== mortgageeTypes.COMPUTERSHARE"
			class="flex justify-between mt-2 gap-4"
		>
			<app-radio-group
				label="Address for service"
				[items]="items"
				name="serviceAddress"
				type="rounded"
				formControlName="institutionAddressForService"
			></app-radio-group>
			<app-radio-group
				label="Address for report"
				[items]="items"
				name="reportAddress"
				type="rounded"
				formControlName="institutionAddressForReport"
			></app-radio-group>
		</div>
		<div class="flex justify-between mt-2 gap-4">
			<app-input
				*ngIf="mortgageeType !== mortgageeTypes.COMPUTERSHARE || create"
				[label]="branchLabel + ' name'"
				name="name"
				[required]="true"
				formControlName="name"
				[submitted]="submitted"
			>
			</app-input>
			<app-input
				*ngIf="showTransitNumber"
				label="Transit number"
				name="transitNumber"
				formControlName="transitNumber"
				type="text"
				[submitted]="submitted"
				[appUniqueFinancialInstitutionBranchNumber]="create ? 'CREATE' : 'EDIT'"
				[appDefaultFinancialInstitutionBranchNumber]="
					defaultInstitutionBranchId
				"
				[appDefaultFinancialInstitutionBranchInstitutionId]="institutionId"
				appDigitsOnly
			>
			</app-input>
		</div>
		<div class="flex mt-2">
			<app-address
				formControlName="address"
				[required]="true"
				[name]="branchLabel + ' address'"
				[submitted]="submitted"
				[enableCountrySelect]="false"
				[showCareOf]="true"
				class="col-span-2"
			>
			</app-address>
		</div>

		<div class="flex mt-6">
			<div class="flex w-1/2 font-bold">
				<span *ngIf="!showDischargeFields"> Contact details</span>
				<span *ngIf="showDischargeFields"> Payout/discharge contact</span>
			</div>
		</div>

		<div *ngIf="!showDischargeFields">
			<app-contact-info-form [group]="form"> </app-contact-info-form>
		</div>

		<div *ngIf="showDischargeFields">
			<app-contact-info-form [group]="form.controls.discharge.controls.primary">
			</app-contact-info-form>
			<app-container
				title="Escalation"
				size="small"
				class="flex-col mt-6 container--dark"
				[collapsable]="true"
				[collapsed]="true"
			>
				<app-contact-info-form
					[group]="form.controls.discharge.controls.escalation"
				>
				</app-contact-info-form>
			</app-container>
		</div>
	</form>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-between">
	<app-button type="button" btn="border" mat-dialog-close>Cancel</app-button>
	<app-button
		[loading]="loading"
		(click)="onSubmit()"
		[disabled]="form.invalid"
	>
		{{ create ? 'Create' : 'Save' }}
	</app-button>
</mat-dialog-actions>
